// GbCore — wraps the vendored roblouie/gameboy-emulator core to
// satisfy the GbEmulatorCore contract for the browser tier. See
// ../PATCHES.md for the edits applied during vendoring.
//
// Everything shared with the headless adapter (./headless.ts) lives in
// ./core-base.ts — including the sprite-introspection readers (palette,
// tiles, sprite height) both tiers need. This file adds only the
// browser-tier extras: the BG + window map snapshots and the background
// palette the devtools panel reads.
import { GbCoreBase } from "./core-base.js";
export const id = "gb-roblouie";
export const label = "Game Boy (roblouie)";
export class GbCore extends GbCoreBase {
    constructor(opts) {
        super({
            emulateSound: opts.emulateSound,
            sampleRate: opts.sampleRate,
            // The browser tier always has a display consuming pixels.
            renderPixels: true,
        });
    }
    // ----- background introspection (devtools-only) -----
    readBackgroundPalette() {
        return this.resolvePalette(this.gb.gpu.backgroundPalette.value & 0xff);
    }
    readBackgroundTilemap() {
        const vram = this.gb.gpu.vram;
        // BG maps live at VRAM offsets $1800-$1BFF and $1C00-$1FFF (i.e.
        // $9800-$9BFF and $9C00-$9FFF in CPU address space). 1 KiB each.
        const bgMap0 = new Uint8Array(vram.buffer, vram.byteOffset + 0x1800, 0x400).slice();
        const bgMap1 = new Uint8Array(vram.buffer, vram.byteOffset + 0x1c00, 0x400).slice();
        const lcdc = this.gb.gpu.lcdControl;
        return {
            bgMap0,
            bgMap1,
            // LCDC bit 3 (backgroundCodeArea): 0 = bgMap0 ($9800), 1 = bgMap1 ($9C00).
            activeBgMap: lcdc.backgroundCodeArea,
            // LCDC bit 6 (windowCodeArea): same mapping for the window layer.
            activeWindowMap: lcdc.windowCodeArea,
            // LCDC bit 4 (backgroundCharacterData): 0 = $8800 signed, 1 = $8000 unsigned.
            bgTileAddressingMode: lcdc.backgroundCharacterData,
            windowEnabled: lcdc.isWindowingOn,
        };
    }
}
export function create(opts) {
    return new GbCore(opts);
}
//# sourceMappingURL=web.js.map